/* eslint-disable react/jsx-max-props-per-line */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Grid, Stack } from '@mui/material';
import { DatePickerV2, TableV2 } from '../../../components/v2';
import { renderStatus } from 'components/v2/cell-renderers/status';
import { getTipoNotaLabel } from '../../../constants/tipoNota';
import { compareNotasByColumns } from '../../../utils/notaSort';

const normalizeValidateStatus = (validate) => validate ?? 'AGUARDANDO_VALIDACAO';

const getValidateLabel = (validate) => {
  const status = normalizeValidateStatus(validate);
  if (status === 'VALIDADO') return 'Validado';
  if (status === 'INVALIDADO') return 'Invalidado';
  return 'Aguardando Validação';
};

const defaultNotasFilter = () => ({
  inicio: moment().subtract(2, 'months').startOf('month').valueOf(),
  fim: moment().endOf('day').valueOf(),
});

const NotasTab = ({ cartaoId }) => {
  const [dateFilter, setDateFilter] = useState(defaultNotasFilter);

  const apiFilter = useMemo(
    () => ({
      cartao: cartaoId,
      inicio: dateFilter.inicio,
      fim: dateFilter.fim,
    }),
    [cartaoId, dateFilter],
  );

  return (
    <Stack spacing={2}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <DatePickerV2
            label="Data Início"
            value={dateFilter.inicio}
            onChange={(inicio) => setDateFilter({ ...dateFilter, inicio })}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <DatePickerV2
            label="Data Fim"
            value={dateFilter.fim}
            onChange={(fim) => setDateFilter({ ...dateFilter, fim })}
          />
        </Grid>
      </Grid>

      <TableV2
        useApi
        fetchUrl="notas/filter"
        rowHeight={56}
        filterData={apiFilter}
        sortComparator={compareNotasByColumns}
        columns={[
          {
            field: 'data',
            headerName: 'Data',
            width: 120,
            renderCell: ({ row }) => moment(Number(row.data)).format('DD/MM/YYYY'),
          },
          {
            field: 'tipo',
            headerName: 'Tipo',
            flex: 0.8,
            minWidth: 140,
            renderCell: ({ row }) => getTipoNotaLabel(row.tipo),
          },
          {
            field: 'valor',
            headerName: 'Valor',
            width: 120,
            renderCell: ({ row }) =>
              row.valor?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
          },
          { field: 'usuarioNome', headerName: 'Inspetor', flex: 0.8 },
          {
            field: 'validate',
            headerName: 'Status',
            width: 180,
            renderCell: ({ value }) =>
              renderStatus({
                value: normalizeValidateStatus(value),
                label: getValidateLabel(value),
              }),
          },
        ]}
      />
    </Stack>
  );
};

NotasTab.propTypes = {
  cartaoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default NotasTab;
